// extracted by mini-css-extract-plugin
export default {"searchFilter":"OfficeManagement_searchFilter__KxSg5"};